// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import { IoFilterOutline } from "react-icons/io5";
import { VscTriangleUp } from "react-icons/vsc";
import { VscTriangleDown } from "react-icons/vsc";
import productCategory from "../helpers/productCategory";
import { useNavigate, useParams } from "react-router-dom";
import FilterProductCart from "../components/FilterProduct/FilterProduct";
import SwiperCard from "../components/SwiperCard/SwiperCard";
function CategoryProduct() {
  const [toggleCategory, setToggleCategory] = useState(false);
  const [togglePrice, setTogglePrice] = useState(false);
  const [sortOrder, setSortOrder] = useState(""); // New state for sorting
  const params = useParams();
  const [category, setCategory] = useState("");
  const navigate = useNavigate();

  const handleCategory = (label) => {
    setCategory(label);
    navigate(`/category-product/${label.toLowerCase()}`);
    setToggleCategory((prev) => !prev);
  };

  const handleSortChange = (event) => {
    setSortOrder(event.target.value);
    setTogglePrice((prev) => !prev);

  };

  useEffect(() => {
    const isLargeScreen = window.innerWidth >= 768; // 768px يُعتبر عرضًا للشاشات الكبيرة
    setToggleCategory(isLargeScreen);
    setTogglePrice(isLargeScreen);
  }, []);

  useEffect(() => {
    if (params?.category) {
      setCategory(params.category);
    }
  }, [params.category]);

  return (
    <div className="container m-auto p-4">
    <SwiperCard />

      <div className="md:flex flex-col md:flex-row gap-4 pt-5 min-h-[300px]  duration-300 transition-all ease-in-out ">
        <div
          style={{ maxHeight: "1000px" }}
          className="flex flex-col gap-2 border border-slate-100 p-4 rounded-lg min-w-[300px] bg-slate-50 overflow-y-scroll transition-all scroll-smooth scroll-none"
        >
          <div className="flex justify-between items-center pt-3">
            <h3 className="text-xl font-bold">Filter</h3>
            <button className="text-2xl  hover:text-blue-700 duration-200 transition-all">
              <IoFilterOutline />{" "}
            </button>
          </div>

          <hr className="w-[100%]  bg-[#799ee8] h-[1px] my-3" />

          <div className="space-y-2 rounded-lg duration-200 transition-all ease-in-out">
            <div
              className="flex justify-between items-center px-3 py-2 mb-5 bg-slate-200 rounded-md cursor-pointer transition-all duration-200 hover:bg-slate-100 hover:ml-1"
              onClick={() => setToggleCategory((prev) => !prev)}
            >
              <strong className="text-lg font-bold">Category</strong>
              <button className="text-lg text-blue-500 hover:text-blue-700 duration-200 transition-all">
                {toggleCategory ? <VscTriangleDown /> : <VscTriangleUp />}
              </button>
            </div>

            {toggleCategory && (
              <ul className="px-3 pb-3 space-y-3 duration-200 transition-all">
                {productCategory.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleCategory(item.label)}
                    className="px-4 py-2 font-medium duration-200 rounded-lg cursor-pointer bg-slate-200 hover:bg-white hover:ml-1"
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            )}

            <div
              className="flex justify-between items-center px-3 py-2 mb-5 bg-slate-200 rounded-md cursor-pointer transition-all duration-200 hover:bg-slate-100 hover:ml-1"
              onClick={() => setTogglePrice((prev) => !prev)}
            >
              <strong className="text-lg font-bold">Price</strong>
              <button className="text-lg text-blue-500 hover:text-blue-700 duration-200 transition-all">
                {togglePrice ? <VscTriangleDown /> : <VscTriangleUp />}
              </button>
            </div>
            {togglePrice && (
              <div className="px-3 pb-3 space-y-3 duration-200 transition-all ">
                <div className="flex items-center gap-3 text-lg font-medium ">
                  {/* <MdKeyboardControlKey /> */}

                  <input
                    name="price"
                    id="asc"
                    type="radio"
                    value="asc"
                    onChange={handleSortChange}
                    checked={sortOrder === "asc"}
                    className="border border-gray-300 rounded-md px-2 py-1 cursor-pointer"
                  />

                  <label htmlFor="asc">Low to High</label>
                </div>
                <div className="flex items-center gap-3 text-lg  font-medium ">
                  {/* <MdKeyboardControlKey /> */}
                  <input
                    name="price"
                    id="desc"
                    type="radio"
                    value="desc"
                    onChange={handleSortChange}
                    checked={sortOrder === "desc"}
                    className="border border-gray-300 rounded-md px-2 py-1 cursor-pointer"
                  />

                  <label htmlFor="price">High to Low</label>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          // style={{ maxHeight: "calc(100vh - 150px)" }}
          className="flex-grow flex flex-col gap-2  rounded-lg  transition-all scroll-smooth scroll-none"
        >
          <FilterProductCart
            category={category.toLowerCase()}
            sortOrder={sortOrder}
          />
        </div>
      </div>
    </div>
  );
}
export default CategoryProduct;
